import { render, staticRenderFns } from "./AbilityScore.vue?vue&type=template&id=0c424d8e&scoped=true"
import script from "./AbilityScore.vue?vue&type=script&lang=js"
export * from "./AbilityScore.vue?vue&type=script&lang=js"
import style0 from "./AbilityScore.vue?vue&type=style&index=0&id=0c424d8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c424d8e",
  null
  
)

export default component.exports